import { boolean, mixed, number, object } from 'yup'
import { isValidLineElementSplit } from './utils'

const pointSchema = object({
  x: number().required('X coordinate is required').defined(),
  y: number().required('Y coordinate is required').defined(),
  z: number().required('Z coordinate is required').defined(),
})

export const splitLineElementSchema = object({
  splitPoint: pointSchema.test({
    name: 'split-point-within-bounds',
    message: 'Projektion des Trennungspunktes muss zwischen Start und Ende liegen',
    test: function (splitPoint) {
      const { element, projectInXY } = this.parent

      if (
        !splitPoint ||
        typeof splitPoint.x !== 'number' ||
        typeof splitPoint.y !== 'number' ||
        typeof splitPoint.z !== 'number' ||
        !element?.shape?.start ||
        !element?.shape?.end
      ) {
        return true
      }

      return isValidLineElementSplit(
        element.shape.start,
        element.shape.end,
        { x: splitPoint.x, y: splitPoint.y, z: splitPoint.z },
        Boolean(projectInXY),
      )
    },
  }),
  projectInXY: boolean().required(),
  element: mixed<ShapeObjectLine>(),
})
